import { useEffect } from 'react';

import { LEADDYNO_PUBLIC_KEY, TOLT_PUBLIC_KEY } from 'consts';
import _ from 'lodash';

declare global {
  interface Window {
    LeadDyno: any;
    tolt: any;
    tolt_data: any;
  }
}

export const recordLeadForLeadDyno = ({
  email,
  firstName,
}: {
  email: string;
  firstName: string;
}) => {
  if (!_.isEmpty(LEADDYNO_PUBLIC_KEY)) {
    window.LeadDyno.recordLead(email, { first_name: firstName, last_name: '' });
  }
};

const LeadDynoWidget = () => {
  useEffect(() => {
    if (!_.isEmpty(LEADDYNO_PUBLIC_KEY)) {
      window.LeadDyno.recordVisit();
      window.LeadDyno.autoWatch();
    }
  }, []);

  return null;
};

// TODO: WIP for switching to the new platform
export const recordLeadForTolt = async ({ email }: { email: string }) => {
  if (!_.isEmpty(TOLT_PUBLIC_KEY)) {
    // eslint-disable-next-line no-console
    console.log('=== Create a tolt customer', email);

    const result = await window.tolt.signup(email);
    // eslint-disable-next-line no-console
    console.log('=== Tolt result', result);
  }
};

export default LeadDynoWidget;
